module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "aside sidebar-wrapper",
    class: {
      'drawer-open': _vm.isDrawerOpen
    }
  }, [_c('div', {
    staticClass: "aside-inner"
  }, [_c('button', {
    staticClass: "drawer-close-btn",
    attrs: {
      "aria-label": "Close menu"
    },
    on: {
      "click": _vm.closeDrawer
    }
  }, [_c('em', {
    staticClass: "fa fa-times"
  })]), _vm._v(" "), _c('nav', {
    staticClass: "sidebar",
    attrs: {
      "data-sidebar-anyclick-close": ""
    }
  }, [_c('ul', {
    staticClass: "nav"
  }, [_c('li', {
    staticClass: "has-user-block"
  }, [_c('div', {
    staticClass: "collapse in",
    attrs: {
      "id": "user-block"
    }
  }, [_c('div', {
    staticClass: "item user-block"
  }, [_c('div', {
    staticClass: "user-block-picture"
  }, [_c('div', {
    staticClass: "user-block-status"
  }, [(_vm.activeAccount) ? _c('img', {
    staticClass: "img-thumbnail img-circle",
    attrs: {
      "src": _vm.getAccountImgUrl(_vm.activeAccount.accountType),
      "alt": "Avatar",
      "width": "60",
      "height": "60"
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "user-block-info"
  }, [(_vm.activeAccount) ? _c('span', {
    staticClass: "user-block-name",
    attrs: {
      "id": "account-name"
    }
  }, [_vm._v(_vm._s(_vm.activeAccount.accountName))]) : _vm._e(), _vm._v(" "), (_vm.activeAccount) ? _c('span', {
    staticClass: "user-block-role"
  }, [_vm._v(_vm._s(_vm.getAccountDescription(_vm.activeAccount.accountType)))]) : _vm._e(), _vm._v(" "), (_vm.isAccountStatusAsPending() && !_vm.isFinancialAdvisor) ? _c('span', {
    staticClass: "status label label-warning"
  }, [_vm._v("Pending")]) : _vm._e(), _vm._v(" "), (_vm.isAccountStatusAsActive() && !_vm.isFinancialAdvisor) ? _c('span', {
    staticClass: "status label label-info"
  }, [_vm._v("Active")]) : _vm._e()])])])]), _vm._v(" "), (_vm.isFinancialAdvisor) ? _c('li', {
    class: {
      active: _vm.$route.name === 'Home'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Home'
      },
      "title": "Home"
    }
  }, [_c('em', {
    staticClass: "fa fa-home"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "data-localize": "sidebar.nav.WIDGETS"
    }
  }, [_vm._v("Home")])])], 1) : _vm._e(), _vm._v(" "), (_vm.activeAccount.accountType !== _vm.accountTypes.ADVISOR.name) ? _c('li', {
    class: {
      active: _vm.$route.name === 'AccountSummary', disabled: _vm.disableSubmit
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'AccountSummary'
      },
      "title": "Account summary"
    }
  }, [_c('em', {
    staticClass: "icon-book-open"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "data-localize": "sidebar.nav.WIDGETS"
    }
  }, [_vm._v("Account summary")])])], 1) : _vm._e(), _vm._v(" "), (_vm.activeAccount.accountType !== _vm.accountTypes.ADVISOR.name && !_vm.isReadOnly) ? _c('li', {
    class: {
      active: _vm.$route.name === 'Notes', disabled: _vm.disableSubmit
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Notes'
      },
      "title": "Investments",
      "replace": ""
    }
  }, [_c('em', {
    staticClass: "fa fa-money"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "data-localize": "sidebar.nav.WIDGETS"
    }
  }, [_vm._v("Investments")])])], 1) : _vm._e(), _vm._v(" "), (_vm.activeAccount.accountType !== _vm.accountTypes.ADVISOR.name && !_vm.isReadOnly) ? _c('li', {
    class: {
      active: _vm.$route.name === 'UpcomingTransactionsForInvestor', disabled: _vm.disableSubmit
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'UpcomingTransactionsForInvestor'
      },
      "title": "Upcoming transactions",
      "replace": ""
    }
  }, [_c('em', {
    staticClass: "fa fa-exchange"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "data-localize": "sidebar.nav.WIDGETS"
    }
  }, [_vm._v("Upcoming transactions")])])], 1) : _vm._e(), _vm._v(" "), (!_vm.isInstitutionAccount && _vm.activeAccount.accountType !== _vm.accountTypes.ADVISOR.name) ? _c('li', {
    class: {
      active: _vm.$route.name === 'AddFundingSource', disabled: _vm.disableSubmit
    }
  }, [_c('router-link', {
    class: {
      'with-notification': !_vm.hasFundingSources
    },
    attrs: {
      "to": {
        name: 'AddFundingSource'
      },
      "title": "Bank accounts"
    }
  }, [_c('em', {
    staticClass: "fa fa-university"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "data-localize": "sidebar.nav.WIDGETS"
    }
  }, [_vm._v("Bank accounts")]), _vm._v(" "), (_vm.hasFundingSources === false && _vm.userProfile.accountType !== 'INSTITUTION') ? _c('notification-icon', {
    attrs: {
      "content": _vm.notificationMessage
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.activeAccount.accountType !== _vm.accountTypes.ADVISOR.name) ? _c('li', {
    class: {
      active: _vm.isPreferencesViewActive, disabled: _vm.disableSubmit, 'accordion-list-background': _vm.preferencesAccordionOpen
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.togglePreferencesAccordion()
      }
    }
  }, [_c('em', {
    staticClass: "fa fa-globe"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "data-localize": "sidebar.nav.WIDGETS"
    }
  }, [_vm._v("Preferences")])]), _vm._v(" "), (_vm.displayedPreferences.length > 0) ? _c('ul', {
    staticClass: "nav accordion-submenu"
  }, _vm._l((_vm.displayedPreferences), function(preference, index) {
    return _c('li', {
      key: ("preference-" + index),
      staticClass: "accordion-list-background",
      class: {
        active: _vm.$route.name === preference.route, disabled: _vm.disableSubmit
      }
    }, [_c('router-link', {
      staticClass: "with-notification",
      attrs: {
        "to": {
          name: preference.route
        },
        "title": preference.title
      }
    }, [_c('span', {
      staticClass: "accordion-list-item-text",
      attrs: {
        "data-localize": "sidebar.nav.WIDGETS"
      }
    }, [_vm._v(_vm._s(preference.title))]), _vm._v(" "), (_vm.displayNotificationIcon(preference)) ? _c('notification-icon', {
      attrs: {
        "content": _vm.notificationMessage
      }
    }) : _vm._e()], 1)], 1)
  })) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      active: _vm.$route.name === 'AccountDocuments', disabled: _vm.disableSubmit, 'accordion-list-background': _vm.documentsAccordionOpen
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.toggleDocumentsAccordion()
      }
    }
  }, [_c('em', {
    staticClass: "fa fa-file-text-o"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "data-localize": "sidebar.nav.WIDGETS"
    }
  }, [_vm._v("Documents")])]), _vm._v(" "), (_vm.documentOptions.length > 0) ? _c('ul', {
    staticClass: "nav accordion-submenu"
  }, _vm._l((_vm.documentOptions), function(document, index) {
    return _c('li', {
      key: ("document-" + index),
      staticClass: "accordion-list-background",
      class: {
        active: _vm.$route.name === document.value, disabled: _vm.disableSubmit
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'AccountDocuments',
          query: {
            type: document.value
          }
        },
        "title": document.text
      }
    }, [_c('span', {
      staticClass: "accordion-list-item-text",
      attrs: {
        "data-localize": "sidebar.nav.WIDGETS"
      }
    }, [_vm._v(_vm._s(document.text))])])], 1)
  })) : _vm._e()]), _vm._v(" "), (_vm.activeAccount.accountType !== _vm.accountTypes.ADVISOR.name) ? _c('li', {
    class: {
      active: _vm.$route.name === 'FeedbackSurvey', disabled: _vm.disableSubmit
    }
  }, [_c('router-link', {
    class: {
      'with-notification': _vm.showFeedbackIndicator
    },
    attrs: {
      "to": {
        name: 'FeedbackSurvey'
      },
      "title": "Feedback"
    }
  }, [_c('em', {
    staticClass: "fa fa-comment-o"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "data-localize": "sidebar.nav.WIDGETS"
    }
  }, [_vm._v("Feedback")]), _vm._v(" "), (_vm.showFeedbackIndicator) ? _c('notification-icon', {
    attrs: {
      "content": 'We\'d love to hear your feedback.'
    }
  }) : _vm._e()], 1)], 1) : _vm._e()]), _vm._v(" "), _vm._m(0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12",
    attrs: {
      "id": "contact-message-container"
    }
  }, [_c('div', {
    staticClass: "alert alert-info alert-dismissible",
    attrs: {
      "role": "alert",
      "id": "contact-message"
    }
  }, [_c('p', [_vm._v("Contact us with any questions:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:info@calvertimpact.org",
      "target": "_blank"
    }
  }, [_vm._v("info@calvertimpact.org")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-baabd36c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SideBar.vue
// module id = 2197
// module chunks = 1